import {createSlice, Draft, PayloadAction} from "@reduxjs/toolkit";
import {AppEnv} from "~/types/app-env-types.ts";

export interface AppEnvState {
    env: AppEnv,
    fetchingEnv: boolean
}

export const initialState: AppEnvState = {
    env: null,
    fetchingEnv: false
}

const slice = createSlice({
    name: 'app-env',
    initialState: initialState,
    reducers: {
        setAppEnv: (draft: Draft<AppEnvState>, {payload}: PayloadAction<AppEnvState>): void => {
            draft.env = payload.env;
            draft.fetchingEnv = false;
        },
        setFetchingEnv: (draft: Draft<AppEnvState>, {payload}: PayloadAction<boolean>): void => {
            draft.fetchingEnv = payload;
        },
    }
});

export const actions = {
    ...slice.actions
};

export default slice.reducer;